// extracted by mini-css-extract-plugin
export default {"actions":"BackAndEdit_actions__MvppM","iconBtn":"BackAndEdit_iconBtn__lJjq+","iconBtnDanger":"BackAndEdit_iconBtnDanger__nCDKm","iconBtnNeutral":"BackAndEdit_iconBtnNeutral__bAYYg"};